"use strict";
var aSet = require("../internals/a-set");
var size = require("../internals/set-size");
var iterate = require("../internals/set-iterate");
var getSetRecord = require("../internals/get-set-record");
module.exports = function isSubsetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) > otherRec.size) return false;
  return iterate(O, function(e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};
